import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { FooterBannerType } from '@/shared/constant/footer-banner/FooterBanner';
import clsx from 'clsx';
import { BottomBannerImage } from './components/bottom-banner-image/BottomBannerImage';
import { BottomBannerQRCode } from './components/bottom-banner-qr-code/BottomBannerQRCode';

export type BottomBannerProps = {
  className?: string;
};

export function BottomBanner(props: BottomBannerProps) {
  const { className } = props;

  const footerBanner = useDocsDataModelStore((x) => x.footerBanner);

  if (!footerBanner.length) {
    return null;
  }
  return (
    <div className={clsx('flex flex-col gap-4', className)}>
      {footerBanner.map((x) => {
        if (x.type === FooterBannerType.QRCode) {
          return <BottomBannerQRCode key={x.key} value={x} />;
        }

        return <BottomBannerImage key={x.key} value={x} />;
      })}
    </div>
  );
}
